import React from 'react';

import { Badge } from '../Badge';

import { RestProps } from './types';
import { Component } from './styles';

export const MobileRest = React.memo(
  React.forwardRef<HTMLSpanElement, RestProps>(({ value }, ref) => (
    <Component>
      <Badge ref={ref}>{value}%</Badge>
    </Component>
  ))
);
